import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { PopoverModule } from 'primeng/popover';

// Composants
import { FormBaseComponent } from 'src/app/@shared/components/abstract/form-base.component';

@Component({
    selector: 'app-danger-zone-form',
    imports: [
        ReactiveFormsModule,
        ButtonModule,
        DividerModule,
        InputTextModule,
        MessageModule,
        PopoverModule,
    ],
    templateUrl: './danger-zone-form.component.html',
    styleUrl: './danger-zone-form.component.scss'
})
export class DangerZoneFormComponent extends FormBaseComponent {

    /*----------------------------------------------------------------------------------------
     * Gestion de la vue
     ----------------------------------------------------------------------------------------*/

    public showDeleteValidation: boolean = false;

    /*----------------------------------------------------------------------------------------
     * Données
     ----------------------------------------------------------------------------------------*/

    public deletePhrase: string | null = null;
    public resetPhrase: string | null = null;

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    public get isDeleteButtonDisabled(): boolean {
        return this.deletePhrase !== 'Supprimer définitivement ' + this.appService.selectedClient?.commercialName;
    }

    public get isOwner(): boolean {
        const ownerUserId = this.appService.selectedClient?.owner?.user?.id;
        return !!ownerUserId && ownerUserId === this.appService.user?.id;
    }

    public get isResetButtonDisabled(): boolean {
        return this.resetPhrase !== 'Réinitialiser ' + this.appService.selectedClient?.commercialName;
    }

    public onClickCancel(): void {
        this.showDeleteValidation = false;
        this.form.reset();
    }

    public override onClickDelete(): void {
        this.showDeleteValidation = true;
    }

    public onClickReset(): void {
        this.appService.uiBlocked = true;
        this.clientService.reset$(this.appService.selectedClient!, this.resetPhrase).subscribe((client) => {
            this.appService.uiBlocked = false;
            this.userService.logout$()
                .subscribe(() => {
                    this.router.navigate(['/login']);
                })
        });
    }

    public onClickValidateDelete(): void {
        this.appService.uiBlocked = true;
        this.clientService.delete$(this.appService.selectedClient!, this.deletePhrase).subscribe(() => {
            this.appService.uiBlocked = false;
            this.appService.unselectClient();
            this.router.navigate(['/home']);
            setTimeout(() => window.location.reload(), 1);
        });
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes protégées
     ----------------------------------------------------------------------------------------*/

    protected override buildForm(): void {
        this.form = this.formBuilder.group({
            deletePhrase: '',
            resetPhrase: '',
        });
    }

    protected override subscribeToObservables(): void {
        this.subscriptions.add(
            this.form.get('deletePhrase')!.valueChanges.subscribe((value: string) => this.deletePhrase = value)
        );
        this.subscriptions.add(
            this.form.get('resetPhrase')!.valueChanges.subscribe((value: string) => this.resetPhrase = value)
        );
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes privées
     ----------------------------------------------------------------------------------------*/

}
